<template>
    <div>
        <div class="app-title">
            <em-view-title ref="emViewTitle" v-bind:crudState="$_emWorkflowTaskMixin_pathType"></em-view-title>
        </div>
        <section class="app-content">
            <div id="entity-viewer" class="content" v-menu-permission="'list'">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <em-workflow-business-data-editor :entity="modelName"
                                                              :allow-edit="false"
                                                              :business-data="$_emWorkflowTaskMixin_businessData">
                            </em-workflow-business-data-editor>
                        </div>
                    </div>
                </div>
            </div>
            <WorkflowProcessLine :processDefinitionKey="$_emWorkflowTaskMixin_processDefinitionKey"
                                 :config="config"
                                 ref="processExecution"
                                 @gotItems="setLocalVariables"
                                 :businessKey="$_emWorkflowTaskMixin_businessKey">
            </WorkflowProcessLine>
            <div id="em-workflow-task-complete" class="content" v-if="$_emWorkflowTaskMixin_isShowTaskComplete">
                <WorkflowTaskComplete ref="processComplete"
                                      use-self-complete-feedback
                                      :task-id="$_emWorkflowTaskMixin_taskId"
                                      :businessKey="$_emWorkflowTaskMixin_businessKey"
                                      :status="$_emWorkflowTaskMixin_businessData.status"
                                      :config="config">
                </WorkflowTaskComplete>
            </div>
        </section>
    </div>
</template>
<script>
// Author Liang Gangqiang
// Date 2021-09-09 14:54:14

import emWorkflowTaskMixin from "@/mixin/em/workflow/task";
import workflowTaskMixins, {WITHOUT_ATTACHMENT_TAG} from "@/components/workflow/mixin/WorkflowTaskMixins";
import WorkflowProcessLine from "@/components/workflow/stuffs/WorkflowProcessLine";
import WorkflowTaskComplete from "@/components/workflow/stuffs/WorkflowTaskComplete";

export default {
    name: "sithMesInventoryOutdoorProcessWorkflowTaskView",
    components: {WorkflowProcessLine, WorkflowTaskComplete},
    mixins: [emWorkflowTaskMixin, workflowTaskMixins],
    computed: {
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        fields() {
            return [
                {
                    key: 'materialCode',
                    label: '物料号'
                },
                {
                    key: 'materialName',
                    label: '物料名称'
                },
                {
                    key: 'amount',
                    label: '数量'
                },
                {
                    key: 'unit',
                    label: '单位'
                },
                {
                    key: 'length',
                    label: '长(mm)'
                },
                {
                    key: 'width',
                    label: '宽(mm)'
                },
                {
                    key: 'height',
                    label: '高(mm)'
                },
                {
                    key: 'weight',
                    label: '重量(t)'
                },
                {
                    key: 'area',
                    label: '面积(m2)'
                },
                {
                    key: 'category',
                    label: '条目类别',
                    type: this.VALUE_TYPE.SELECT,
                    optionFrom: {
                        entity: 'sithMesInventoryOutdoorProductCategory',
                        value: 'id',
                        name: 'name'
                    }
                },
                {
                    key: 'borrower',
                    label: '借出人'
                },
            ];
        },
        config() {
            return {
                defaultCandidateUser: true,
                'task_outdoor_init': {
                    tag: {},
                    name: '创建出场申请',
                    variables: [
                        {
                            label: '流程管理',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.APPROVE,
                            options: [
                                {value: 1, text: '发起流程'},
                                {value: 4, text: '流程结束'}
                            ],
                            changeTag: val => {
                                return this.buildTag('notClose', val === 1);
                            }
                        },
                        {
                            needTag: 'notClose',
                            label: '出门类型',
                            name: 'type',
                            type: this.VALUE_TYPE.SELECT,
                            saveTo: this.SAVE_TO.DATABASE,
                            options: [
                                {value: 11, text: 'A类-非销售'},
                                {value: 12, text: 'B类-销售产成品'},
                                {value: 13, text: 'C类-销售非产成品'},
                            ],
                            initData: true,
                            changeTag: val => {
                                return this.buildTag('type_a', val === 11);
                            }
                        },
                        {
                            needTag: 'type_a',
                            label: '出厂明细与返回物品是否一致',
                            name: 'isSame',
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '一致'},
                                {value: 2, text: '不一致'},
                            ],
                            require: true,
                            changeTag: val => {
                                return this.buildTag('different', val === 2);
                            }
                        },
                        {
                            needTag: 'different',
                            label: '不一致理由',
                            name: 'differentReason',
                            type: this.VALUE_TYPE.TEXTAREA,
                        },
                        {
                            label: '出厂物品',
                            name: 'outdoorDetails',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.fields,
                            entityName: 'sithMesInventoryOutdoorProductDetail',
                            filterHolder: {
                                outdoorIdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                itemTypeFilter: 1
                            },
                            saveHolder: {
                                outdoorId: this.$_emWorkflowTaskMixin_businessKey,
                                itemType: 1
                            }
                        },
                        {
                            needTag: 'different',
                            label: '返回物品',
                            name: 'returnDetails',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.fields,
                            entityName: 'sithMesInventoryOutdoorProductDetail',
                            filterHolder: {
                                outdoorIdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                itemTypeFilter: 2
                            },
                            saveHolder: {
                                outdoorId: this.$_emWorkflowTaskMixin_businessKey,
                                itemType: 2
                            }
                        },
                    ],
                    setApproveByVariable: [
                        {
                            variableName: 'type',
                            handler: (approve, val) => {
                                if (approve === 1 && val) {
                                    switch (val) {
                                        case 12:
                                            return 2;
                                        case 13:
                                            return 3;
                                    }
                                }
                                return approve;
                            }
                        },
                        {
                            variableName: 'isSame',
                            handler: (approve, val) => {
                                if (approve === 1 && val) {
                                    switch (val) {
                                        case 1:
                                            return 11;
                                        case 2:
                                            return 12;
                                    }
                                }
                                return approve;
                            }
                        }
                    ],
                    userSelectMap: {
                        12: [{
                            name: 'task_tc_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        2: [{
                            name: 'task_pm_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        '3,11': [{
                            name: 'task_requirement_manager_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        12: 'task_tc_confirm',
                        2: 'task_pm_confirm',
                        '3,11': 'task_requirement_manager_confirm',
                        4: 'Event_end_1'
                    },
                    defaultAssignee: true
                },
                'task_tc_confirm': {
                    name: 'TC判定',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_requirement_manager_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_requirement_manager_confirm',
                        2: 'task_outdoor_init',
                        3: 'Event_end_2'
                    }
                },
                'task_pm_confirm': {
                    name: 'PM审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_cpm_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_cpm_confirm',
                        2: 'task_outdoor_init',
                        3: 'Event_end_1'
                    }
                },
                'task_cpm_confirm': {
                    name: 'CPM审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_delivery_complement_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_delivery_complement',
                        2: 'task_pm_confirm',
                        3: 'Event_end_1'
                    }
                },
                'task_requirement_manager_confirm': {
                    name: '需求部门经理审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 1) {
                            if (this.taskLocalVariables.hasOwnProperty('type')) {
                                switch (this.taskLocalVariables.type) {
                                    case 11:
                                        return 11;
                                    case 13:
                                        return 12;
                                }
                            }
                        }
                        return approve;
                    },
                    userSelectMap: {
                        11: [{
                            name: 'task_delivery_complement_candidateUsers',
                            allowMulti: true,
                            require: true
                        }],
                        12: [{
                            name: 'task_ba_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        11: 'task_delivery_complement',
                        12: 'task_ba_confirm',
                        2: 'task_outdoor_init',
                        3: 'Event_end_1'
                    }
                },
                'task_ba_confirm': {
                    name: 'BA经理审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_delivery_complement_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_delivery_complement',
                        2: 'task_requirement_manager_confirm',
                        3: 'Event_end_2'
                    }
                },
                'task_delivery_complement': {
                    name: '物流发货员补充信息',
                    variables: [
                        {
                            label: '出厂物品',
                            name: 'outdoorDetails',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.fields,
                            entityName: 'sithMesInventoryOutdoorProductDetail',
                            filterHolder: {
                                outdoorIdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                itemTypeFilter: 1
                            },
                            saveHolder: {
                                outdoorId: this.$_emWorkflowTaskMixin_businessKey,
                                itemType: 1
                            }
                        },
                        {
                            needTag: 'different',
                            label: '返回物品',
                            name: 'returnDetails',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.fields,
                            entityName: 'sithMesInventoryOutdoorProductDetail',
                            filterHolder: {
                                outdoorIdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                itemTypeFilter: 2
                            },
                            saveHolder: {
                                outdoorId: this.$_emWorkflowTaskMixin_businessKey,
                                itemType: 2
                            }
                        },
                        {
                            label: '需求车辆吨位',
                            name: 'vehicleTonnage',
                            type: this.VALUE_TYPE.INPUT,
                            saveTo: this.SAVE_TO.DATABASE,
                            initData: true
                        },
                        {
                            label: '是否需要还回',
                            name: 'needReturn',
                            type: this.VALUE_TYPE.SELECT,
                            options: [
                                {value: 1, text: '是'},
                                {value: 2, text: '否'},
                            ],
                            require: true,
                        }
                    ],
                    withComment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_inventory_manager_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: 'task_inventory_manager_confirm'
                },
                'task_inventory_manager_confirm': {
                    name: '物流经理审批',
                    variables: [{
                        label: '是否同意',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_do_package_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_do_package',
                        2: 'task_delivery_complement',
                        3: 'Event_end_2'
                    }
                },
                'task_do_package': {
                    name: '物流现场操作员准确装车',
                    approveLabel: '是否通过',
                    variables: [
                        {
                            label: '车牌号',
                            name: 'car_code',
                            type: this.VALUE_TYPE.INPUT
                        },
                        {
                            label: '实际车辆吨位',
                            name: 'currentVehicleTonnage',
                            type: this.VALUE_TYPE.INPUT,
                        },
                        {
                            label: '出厂物品',
                            name: 'outdoorDetails',
                            type: this.VALUE_TYPE.TABLE,
                            fields: this.fields,
                            entityName: 'sithMesInventoryOutdoorProductDetail',
                            filterHolder: {
                                outdoorIdFilter: this.$_emWorkflowTaskMixin_businessKey,
                                itemTypeFilter: 1
                            },
                            saveHolder: {
                                outdoorId: this.$_emWorkflowTaskMixin_businessKey,
                                itemType: 1
                            }
                        },
                    ],
                    changeTag: (bd, approve) => {
                        return this.buildTag(WITHOUT_ATTACHMENT_TAG, approve === 2);
                    },
                    withComment: true,
                    withAttachmentNotNull: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_delivery_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_delivery_confirm',
                        2: 'task_inventory_manager_confirm'
                    }
                },
                'task_delivery_confirm': {
                    name: '物流发货员核对信息',
                    variables: [{
                        label: '是否正确',
                        type: this.VALUE_TYPE.SELECT,
                        saveTo: this.SAVE_TO.APPROVE,
                        options: [
                            {value: 1, text: '是'},
                            {value: 2, text: '否'},
                            {value: 3, text: '结束流程'}
                        ]
                    }],
                    withComment: true,
                    userSelectMap: {
                        1: [{
                            name: 'task_do_outdoor_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: {
                        1: 'task_do_outdoor',
                        2: 'task_do_package',
                        3: 'Event_end_2'
                    }
                },
                'task_do_outdoor': {
                    name: '出门',
                    approveLabel: '是否通过',
                    withComment: true,
                    withAttachmentNotNull: true,
                    setApproveBeforeSubmit: approve => {
                        if (approve === 1) {
                            if (this.taskLocalVariables.hasOwnProperty('needReturn')) {
                                if (this.taskLocalVariables.needReturn === 1) {
                                    return 3;
                                }
                            }
                        }
                        return approve;
                    },
                    approveToNextTask: {
                        1: 'Event_end_2',
                        2: 'task_delivery_confirm',
                        3: 'task_do_return'
                    }
                },
                'task_do_return': {
                    name: '物品归还',
                    withComment: true,
                    withAttachment: true,
                    userSelectMap: {
                        '*': [{
                            name: 'task_return_confirm_candidateUsers',
                            allowMulti: true,
                            require: true
                        }]
                    },
                    approveToNextTask: 'task_return_confirm'
                },
                'task_return_confirm': {
                    name: '部门经理确认归还',
                    withComment: true,
                    approveToNextTask: 'Event_end_2'
                },
                'Event_end_1': {
                    name: '结束',
                    isOver: true
                },
                'Event_end_2': {
                    name: '结束',
                    isOver: true
                }
            }
        }
    }
};
</script>